module.exports = __webpack_public_path__ + "static/img/wpp1bg_m.7e77b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp1bg_m.png
// module id = p1gX
// module chunks = 2